<div [ngClass]="{'form-layout-compact': useCompactFormLayout}">
  @if (sortFields?.length > 0) {
    <div class="field">
      <label soho-label for="lm-add-sort-sort-field-filter">{{'FindASortWith' | translate}}</label>
      <select data-automation-id="lm-add-sort-sort-field-filter"
        [attributes]="addSortFieldFilterDropdownAttributes"
        soho-dropdown
        [multiple]="true"
        [moveSelectedToTop]="true"
        soho-alert
        attr.placeholder="{{'AvailableSortFields' | translate}}"
        id="lm-add-sort-sort-field-filter"
        name="lm-add-sort-sort-field-filter"
        [(ngModel)]="selectedSortFields"
        (change)="onSortFieldsChange()">
        @for (item of sortFields; track item) {
          <option [value]="item">{{item}}</option>
        }
      </select>
    </div>
  }

  <div class="flex-row-container ">
    <div class="field padding">
      <label soho-label [required]="true" for="lm-add-sort-sort-name">{{'SortBy' | translate}}</label>
      <select data-automation-id="lm-add-sort-sort-name"
        [attributes]="addSortSortNameDropdownAttributes"
        soho-dropdown
        [source]="sortNameSource"
        soho-alert
        attr.placeholder="{{'AvailableSets' | translate}}"
        id="lm-add-sort-sort-name"
        name="lm-add-sort-sort-name"
        [(ngModel)]="sortOrder"
        (change)="onSortChange()">
        @for (item of sortNames; track item) {
          <option [value]="item.value">{{ item.label }}</option>
        }
      </select>
    </div>
    @if (request.columns?.length > 0) {
      <div class="field">
        <label soho-label [required]="true" for="lm-add-sort-column-index">{{'UseOnColumn' | translate}}</label>
        <select #ColumnField data-automation-id="lm-add-sort-column-index"
          [attributes]="addSortColumnIndexDropdownAttributes"
          soho-dropdown
          soho-alert
          noSearch
          id="lm-add-sort-column-index"
          name="lm-add-sort-column-index"
          attr.placeholder = "{{'AvailableColumns' | translate}}"
          [(ngModel)]="columnIndex"
          (change)="onColumnChange()">
          @for (item of request.columns; track item) {
            <option [value]="item.index">{{item.name}}</option>
          }
        </select>
      </div>
    }
  </div>
  <div class="flex-row-container">
    <div class="field padding">
      <input data-automation-id="lm-add-sort-default-checkbox"
        checkbox
        type="checkbox"
        class="checkbox"
        id="lm-add-sort-default-checkbox"
        name="lm-add-sort-default-checkbox"
        [(ngModel)]="default"
        (change)="onDefaultChange()">
        <label soho-label [forCheckBox]="true" for="lm-add-sort-default-checkbox">{{'MakeDefaultLabel' | translate}}</label>
      </div>
      <div class="field">
        <input data-automation-id="lm-add-sort-descending-checkbox"
          checkbox
          type="checkbox"
          class="checkbox"
          id="lm-add-sort-descending-checkbox"
          name="lm-add-sort-descending-checkbox"
          [disabled] = "!default"
          [(ngModel)]="descending">
          <label soho-label [forCheckBox]="true" for="lm-add-sort-descending-checkbox">{{'ListPersonalizationSortDescendingLabel' | translate}}</label>
        </div>
      </div>
      <div class="flex-row-container">
        <div data-automation-id="lm-add-sort-widget"
          class="lm-add-sort-widget-container">
          <div>
            <div soho-widget-content data-automation-id="lm-add-sort-widget-content"
              class="widget lm-add-sort-widget" >
              <!-- HEADER -->
              <div class="lm-add-sort-widget-header">
                <div>
                  @if (request.setSpecs[sortOrder]?.condition) {
                    <svg soho-icon data-automation-id="lm-add-sort-instance-selection-alert"
                      icon="info"
                      class="icon-alert-solid lm-add-sort-alert-icon"
                    soho-tooltip [content]="request.setSpecs[sortOrder].condition"></svg>
                  }
                  <span attr.data-automation-id="lm-add-sort-by-label"
                    class="lm-bold lm-font-md"
                    >{{'SortBy' | translate}}
                  </span>
                </div>
              </div>
              <!-- CONTENT -->
              <div class="lm-add-sort-field-container">
                <!-- SORT FIELDS -->
                @if (request.setSpecs[sortOrder]) {
                  <ul>
                    @for (sortField of request.setSpecs[sortOrder].sortFields; track sortField) {
                      <li attr.data-automation-id="lm-add-sort-{{sortField.name}}-sort-field">
                        @if (sortField.sortBreak) {
                          <label
                            class="lm-font-sm">*
                          </label>
                        }
                        <label attr.data-automation-id="lm-add-sort-{{sortField.name}}-sort-field-name"
                          class="lm-font-sm lm-add-sort-field-name-container"
                          [style.text-indent]="sortField.sortBreak ? '0px' : '8px'"
                          soho-tooltip [content]="sortField.name">{{sortField.name}}
                        </label>
                        @if (sortField.descending) {
                          <svg soho-icon attr.data-automation-id="lm-add-sort-{{sortField.name}}-sort-field-descending"
                            icon="sort-z-to-a"
                            class="icon-alert-solid lm-add-sort-alert-icon">
                          </svg>
                        }
                      </li>
                    }
                  </ul>
                }
              </div>
              <div class="lm-add-sort-widget-footer">
                <span data-automation-id="lm-add-sort-sort-break-text"
                  class="lm-font-xs">{{ 'ColumnEditorSubTotalBreakPointMessage' | translate }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>